import React from "react";
import { useTranslation, Trans } from "react-i18next";
import i18nStringWrapper from "i18n/i18nStringWrapper";
import i18next from "i18next";

import type { WithTranslation } from "react-i18next";

/**
 * @types/react@18 では ReactNode に `{}` が含まれなくなったため、withTranslation の
 * t (i18next@19 の TFunction) を JSX の children に直接書くと戻り値が
 * TFunctionResult (object を含む) に推論されて型エラーになる。
 * t を string 返却として扱うための WithTranslation 代替型。
 * i18next@21 以降 (t がデフォルトで string を返す) に上げたら WithTranslation に戻す。
 */
export type WithStringTranslation = Omit<WithTranslation, "t"> & {
  t: (
    key: string | string[],
    options?: Record<string, unknown> | string
  ) => string;
};

export const useI18n = () => {
  const { t, i18n } = useTranslation();
  return {
    // @ts-expect-error TS7006
    t: (str: Parameters<typeof i18nStringWrapper>[0], option?) =>
      t(i18nStringWrapper(str), option),
    i18n,
  };
};

export const i18nextT = (
  str: Parameters<typeof i18nStringWrapper>[0],
  // @ts-expect-error TS7006
  option?
) => {
  return i18next.t(str, option);
};

interface i18nParameter {
  i18nKey: Parameters<typeof i18nStringWrapper>[0];
}

export const I18nTrans: React.FC<React.PropsWithChildren<i18nParameter>> = (
  props
) => {
  return <Trans i18nKey={props.i18nKey}>{props.children}</Trans>;
};
